import { z } from 'zod';
import { RepaymentType } from '..';
import { requiredString } from '../helper';
import { applicantMetadata, directDebitAgreement } from '../shared';

const directDebitSchema = z.object({
  accountName: requiredString(),
  bsb: z.string().regex(/^\d{6}$/, 'BSB must be 6 digits'),
  accountNumber: requiredString(),
});

const creditCardSchema = z.object({
  cardHolder: requiredString(),
  cardNumber: requiredString(),
  cardExpiry: requiredString(),
  token: requiredString(),
  cardType: requiredString(),
});

const paymentSchema = z
  .discriminatedUnion('type', [
    z.object({
      type: z.literal('DEBIT'),
      methodId: z.string().trim(),
      directDebit: directDebitSchema,
    }),
    z.object({
      type: z.literal('CARD'),
      methodId: z.string().trim(),
      creditCard: creditCardSchema,
    }),
  ])
  .superRefine((data, ctx) => {
    if (
      'directDebit' in data &&
      !data.methodId &&
      data?.directDebit &&
      data?.directDebit?.accountNumber &&
      !/^\d{6,10}$/.test(data.directDebit.accountNumber)
    ) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        path: ['directDebit', 'accountNumber'],
        message: 'Account number must be between 6 and 10 digits',
      });
    }
  });

export const repaymentAccountWithTermsSchema = z.object({
  applicant: applicantMetadata.pick({ type: true }).and(z.object({ termsAndConditions: directDebitAgreement })),
  payment: paymentSchema,
});

export type RepaymentAccountType = {
  applicant: {
    type: string;
    termsAndConditions: {
      directDebitStatement: string;
      authoriseBrighteStatement: string;
    };
  };
  payment: {
    type: RepaymentType;
    methodId: string;
    directDebit?: {
      accountName: string;
      bsb: string;
      accountNumber: string;
    };
    creditCard?: {
      cardHolder: string;
      cardNumber: string;
      cardExpiry: string;
      token: string;
      cardType: string;
    };
  };
};
